import { useState } from "react";

/** Client-side slug suggestion — mirrors the API's slugify. */
export function slugify(input: string): string {
  return input
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/\.md$/, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 100)
    .replace(/-+$/g, "");
}

/**
 * Slug state for a form. Until the user edits the slug by hand, it auto-follows
 * the title via `suggestFrom`. On edit, the existing slug is treated as
 * user-owned so it stops tracking.
 */
export function useSlugField(initialSlug: string) {
  const [slug, setSlugState] = useState(initialSlug);
  const [dirty, setDirty] = useState(initialSlug.trim() !== "");

  const setSlug = (v: string) => {
    setSlugState(v);
    setDirty(v.trim() !== "");
  };
  const suggestFrom = (title: string) => {
    if (!dirty) setSlugState(slugify(title));
  };
  return { slug, setSlug, suggestFrom };
}
